import Image from 'next/image';

import { Button } from '../../../ui';

export const Confirmation = ({
  handleCloseModal,
}: {
  handleCloseModal: () => void;
}) => {
  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-4 items-center">
        <span className="text-text-secondary max-w-[640px] text-center">
          Thank you for submitting your capital request! Your request has been
          successfully received. We are now working to find capital providers
          who are interested in your opportunity. Once we have matches, we will
          notify you promptly.
        </span>
        <span className="text-text-secondary max-w-[640px] text-center">
          Thank you for choosing Scaleup to support your business growth.
          We&apos;ll keep you informed of any updates regarding your request.
        </span>
        <Button
          suffixIcon="/icons/arrow_right.svg"
          text="Go Home"
          variant="primary"
          onClick={handleCloseModal}
        />
      </div>
      <Image
        src="/confirmation_cr.png"
        alt="Confirmation"
        width={1024}
        height={300}
        style={{ objectFit: 'contain' }}
      />
    </div>
  );
};
